module.exports = __webpack_public_path__ + "img/link-square.fbafa023.svg";